export const maintenanceScheduleItemOrder = [
  'As Needed',
  'Daily Check',
  'Annually',
  'Every X Years',
  'Every X Months',
  'Seasonally',
  'X Years',
  'X Months',
  'X Hours',
  'Every X Hours',
];
